import styled from 'styled-components';

export const Container = styled.div`
  color: #505059;

  .info {
    cursor: pointer;
  }

  h1 {
    font-size: 25px;
    margin: 0;
  }

  nav {
    display: block;
    margin: 25px 30px;

    .link-back {
      font-family: Poppins, Heltica, Arial, sans-serif;
      font-size: 14px;
      color: #505059;
    }
  }

  .box {
    margin: 30px;

    h2 {
      font-family: Poppins-Medium, Heltica, Arial, sans-serif;
      font-size: 14px;
      margin: 0;
    }

    .fa-columns {
      font-size: 18px;
      color: #F24952;
      margin-right: 10px;
    }
  }
`;
